import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";
import useWhitelabel from "hooks/useWhitelabel";
// The legacy page carries the whitelabel header/footer; V2 is Amber-branded only.
import WhitelabelTerms from "@Pages/Terms";

const AsyncTermsV2 = loadable(() => import("./TermsV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isWhitelabel } = useWhitelabel();

  if (isWhitelabel) return <WhitelabelTerms {...props} />;

  return (
    <ErrorBoundary>
      <AsyncTermsV2 {...props} />
    </ErrorBoundary>
  );
};
